if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.storagekey = 'megamenu'
    }
  
    connectedCallback() {
      // this.ajaxMenu();
      // this.bindEvents();
      this.init()
      this.loadMenuInbackground()
    }
  
    ajaxMenu() {
      // this.navMenuContainer = this.navMenuContainer || this.querySelector('.js-menu-nav');
  
      // const templateMenu = this.querySelector('.js-menu-template');
      // const templateHTML = templateMenu.content.firstElementChild.cloneNode(true).innerHTML;
  
      // if (templateHTML) {
      //   this.navMenuContainer.innerHTML = templateHTML;
      // }
    }

    isExists() {
      const el = document.querySelector('.mega-menu__dropdown')
      return el.children.length > 0 
    }

    async loadMenuInbackground() {
      const res = await fetch(`/?sections=mega-menu-dropdown`)
      const data = await res.json()
      // console.log(data)
      const megamenuData = {
        dated: new Date,
        html: data['mega-menu-dropdown']
      }
      localStorage.setItem(this.storagekey, JSON.stringify(megamenuData))

      return megamenuData
    }

    getMenuData() {
      const megamenu = localStorage.getItem(this.storagekey)
      const data = JSON.parse(megamenu)
      // console.log(data)

      if(megamenu) {
        var startDate = new Date(data?.dated);
        var endDate   = new Date();
        var timeDiff = (endDate.getTime() - startDate.getTime());
        let days = Math.round(timeDiff / (1000 * 3600 * 24));
        // console.log(days)

        // if menu was created past 7 days then expire it
        if(days > 7) {
          localStorage.removeItem(this.storagekey)
          return null
        }

        return data
      }

      return null
    }

    async loadMenu() {
      if(this.isExists()) return;
 
      let loader = new SpinLoader()
      loader.show()
      
      // const res = await fetch(`/?sections=mega-menu-dropdown`)
      // const data = await res.json()
      // const html = new DOMParser().parseFromString(data['mega-menu-dropdown'], 'text/html');

      let megamenuData = this.getMenuData()
      if(!megamenuData) {
        megamenuData = await this.loadMenuInbackground()
      }
      const html = new DOMParser().parseFromString(megamenuData['html'], 'text/html');

      
      const targetElement = document.querySelector('.mega-menu__dropdown');
      const sourceElement = html.querySelector('.mega-menu__dropdown');
      targetElement.appendChild(sourceElement.children[0])
      this.bindEvents()
      loader.destroy()
      
      // .then(response => response.json())
      // .then(data => {
      //     const html = new DOMParser().parseFromString(data['mega-menu-dropdown'], 'text/html');
      //     const targetElement = document.querySelector('body');
      //     const sourceElement = html.querySelector('.mega-menu__dropdown');
          
      //     // this.id = 'a' +  this.random()
      //     // sourceElement.setAttribute('id', this.id );
  
      //     targetElement.appendChild(sourceElement.children[0])
      //     this.bindEvents()
      // });
    }

    init() {
      this.htmlElement = document.documentElement;
      this.header = document.querySelector('.js-header');
      this.topBar = document.querySelector('.js-topbar');
      this.uspV2 = document.querySelector('.js-usp-v2');
      this.menuBtn = this.header.querySelector('.js-menu-toggle-btn');
      this.toggleMenuWithBtn();

      this.linksLv0 = this.header.querySelectorAll('.js-mega-menu-link-lv0');
     
      this.showSubMenuDetails();
    }
    
    bindEvents() {
      /* SETUP VARIABLES */
      // this.htmlElement = document.documentElement;
      // this.header = document.querySelector('.js-header');
      // this.topBar = document.querySelector('.js-topbar');
      // this.uspV2 = document.querySelector('.js-usp-v2');
      this.headerSearch = this.querySelector('.js-search-inner');
      this.headerMenuClose = this.querySelector('.js-menu-close');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
  
      // this.menuBtn = this.header.querySelector('.js-menu-toggle-btn');
      this.overlay = this.header.querySelector('.js-header-overlay');
      // this.linksLv0 = this.header.querySelectorAll('.js-mega-menu-link-lv0');
      this.menuLv1 = this.header.querySelector('.js-menu-lv1');
      this.linksLv1 = this.header.querySelectorAll('.js-mega-menu-link-lv1');
      this.menuLv2 = this.header.querySelectorAll('.js-menu-lv2');
      this.linksLv2 = this.header.querySelectorAll('.js-mega-menu-link-lv2');
      this.menuLv3 = this.header.querySelectorAll('.js-menu-lv3');
      this.backPrevBtns = this.header.querySelectorAll('.js-submenu-back');
  
      this.menuSearch = this.querySelector('.js-menu-search');
      this.navigationSearch = this.querySelector('.js-navigation-search');
      this.navigationTitle = this.querySelector('.js-navigation-title');
      this.navigationSearchBtn = this.querySelector('.js-navigation-search-btn');
      this.navigationSearchSubmit = this.querySelector('.js-navigation-search-submit');
      this.navigationSearchInput = this.querySelector('.js-navigation-search-input');
  
      this.searchResults = this.querySelector('.js-search-results');
      this.menuRating = this.querySelector('.js-menu-rating');
      this.menuItemsLevel1 = this.querySelectorAll('.js-menu-item-lv1');
      this.menuFunctions = this.querySelector('.js-menu-functions');
  
      this.megaBody = this.header.querySelectorAll('.js-mega-body');
      this.megaMenuNav = this.header.querySelectorAll('.js-mega-menu-nav');
      this.bodyLock = this.header.querySelector('.js-menu-body-lv1');
      this.preventReveal = false;
      this.headerBounds = {};
      this.currentScrollTop = 0;
  
      /* SETUP PROPERTIES AND EVENTS FOR HEADER HEIGHT */
      window.addEventListener('scroll', this.fixedMenu.bind(this), false);
  
      /* HEADER TOGGLE MENU / SUB-MENU */
      this.setHeaderHeight();
      // this.toggleMenuWithBtn();
      // this.showSubMenuDetails();
      this.addSubMenu(this.linksLv1, this.menuLv2, 2);
      this.addSubMenu(this.linksLv2, this.menuLv3, 3);
      this.backPrevSub();
      this.navigationSearchEvents();
      this.onCloseMenu();
      this.overlayCloseMenu();
      this.renderPreviousSearches();
    }
  
    /**************************
    [START]: SEARCH MODULES
    ***************************/
    navigationSearchEvents() {
      // Open open Input
      this.navigationSearchBtn.addEventListener('click', () => {
        this.navigationSearchBtn.classList.add('hidden');
        this.navigationTitle.classList.add('hidden');
        this.headerMenuClose.classList.add('is-searching');
        this.menuSearch.classList.remove('hidden');
        this.navigationSearch.classList.remove('hidden');
        this.navigationSearchInput.focus();
  
        this.searchResults.classList.remove('hidden');
        [...this.menuItemsLevel1, this.menuRating, this.menuFunctions].forEach((menuItem) =>
          menuItem.classList.add('hidden')
        );
      });
  
      // Search input events
      this.navigationSearchInput.addEventListener(
        'input',
        window.debounce((e) => {
          this.getSearchResults(this.navigationSearchInput.value);
        })
      );
    }
  
    async getSearchResults(searchTerm) {
      const colorSwatchList = searchTerm.split(' ');
  
      if (!searchTerm) {
        return (this.searchResults.innerHTML = '');
      }
  
      /* Fetch predictive search results: variants.sku: */
      await fetch(
        `/search/suggest?q=${searchTerm}&resources[type]=product,collection,article&resources[limit]=9&resources[limit_scope]=each&section_id=predictive-search`
      )
        .then((response) => response.text())
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
  
          // const viewAllEl = resultsMarkup.querySelector('.js-predictive-search-count');
          // viewAllEl && (viewAllEl.innerHTML = this.resultCount);
  
          this.searchResults.classList.remove('hidden');
          [...this.menuItemsLevel1, this.menuRating, this.menuFunctions].forEach((menuItem) =>
            menuItem.classList.add('hidden')
          );
  
          this.searchResults.innerHTML = resultsMarkup.innerHTML;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          window.updateLazyLoad();
  
          this.renderPreviousSearches();
  
          window.debounce(() => {
            this.searchResults.querySelectorAll('.js-product-card').forEach((productCard) => {
              productCard?.updateMedia(colorSwatchList);
            });
          }, 400)();
        });
    }
  
    renderPreviousSearches() {
      const searchHistories = this.querySelectorAll('.js-search-histories');
      let previousSearches = localStorage.getItem('badno_searches_history');
  
      searchHistories.forEach((searchHistory) => {
        searchHistory.classList.add('hidden');
  
        if (!previousSearches) {
          return searchHistory.classList.add('hidden');
        } else {
          searchHistory.classList.remove('hidden');
        }
  
        if (previousSearches) {
          previousSearches.split(', ').map((searchHistory, index) => {
            const searchHTML = `<a href="${window.routes.search}?q=${searchHistory.replace(
              ' ',
              '+'
            )}" class="mega-menu__recentViews-previousSearch">${searchHistory}</a>`;
  
            const matchSlides = this.querySelectorAll(
              `.js-previous-search[data-index="${index + 1}"]`
            );
  
            matchSlides.forEach((matchSlide) => {
              matchSlide.innerHTML = searchHTML;
              searchHistory?.classList?.remove('hidden');
            });
          });
        }
      });
    }
    /**************************
    [END]: SEARCH MODULES
    ***************************/
  
    /**************************
    [START]: TOGGLE MENU MODULES
    ***************************/
    onCloseMenu() {
      this.headerMenuClose.addEventListener('click', () => {
        if (this.headerMenuClose.classList.contains('is-searching')) {
          this.navigationSearch.classList.add('hidden');
          this.menuSearch.classList.add('hidden');
  
          this.navigationSearchBtn.classList.remove('hidden');
          this.navigationTitle.classList.remove('hidden');
          this.headerMenuClose.classList.remove('is-searching');
  
          this.navigationSearchInput.value = '';
  
          [...this.menuItemsLevel1, this.menuRating, this.menuFunctions].forEach((menuItem) =>
            menuItem.classList.remove('hidden')
          );
        } else this.toggleMenu();
      });
    }
  
    overlayCloseMenu() {
      this.overlay.addEventListener('click', () => {
        this.toggleMenu();
      });
    }
  
    setHeaderHeightDefault() {
      let jsNavHeight = (visualViewport?.height ?? window.innerHeight) * 0.01;
      jsNavHeight = Math.floor(jsNavHeight * 10) / 10
      this.style.setProperty(
        '--js-navigation-height',
        `${jsNavHeight}px`
      );
  
      this.style.setProperty('--js-header-height', `${this.header?.offsetHeight || 0}px`);
      let jsHeaderBottom = this.getBoundingClientRect().bottom || 0;
      jsHeaderBottom = Math.floor(jsHeaderBottom * 10) / 10
      this.style.setProperty('--js-header-bottom', `${jsHeaderBottom}px`);
    }
  
    setHeaderHeight() {
      this.setHeaderHeightDefault();
  
      const debouncedFn = window.debounce(() => {
        let jsNavHeight = (visualViewport?.height ?? window.innerHeight) * 0.01;
        jsNavHeight = Math.floor(jsNavHeight * 10) / 10
        this.style.setProperty(
          '--js-navigation-height',
          `${jsNavHeight}px`
        );
    
  
        this.style.setProperty('--js-header-height', `${this.header?.offsetHeight || 0}px`);
        jsHeaderBottom = Math.floor(jsHeaderBottom * 10) / 10
        this.style.setProperty('--js-header-bottom', `${jsHeaderBottom}px`);  
      }, 100);
  
      window.addEventListener('resize', debouncedFn);
    }
  
    fixedMenu() {
      if (this.menuLv1.classList.contains('is-open')) {
        const headerHeight = this.header.offsetHeight,
          topBarHeight = this.topBar?.offsetHeight || 0,
          SCROLL_POINT = headerHeight + topBarHeight;
  
        if (window.scrollY > SCROLL_POINT) {
          this.classList.remove('is-fixed-menu');
          this.menuLv1.classList.add('is-fixed');
          if (this.topBar) this.topBar.classList.remove('is-fixed-menu');
          if (this.uspV2) this.uspV2.classList.remove('is-fixed-menu');
        } else {
          this.classList.add('is-fixed-menu');
          this.menuLv1.classList.remove('is-fixed');
  
          if (this.topBar) this.topBar.classList.add('is-fixed-menu');
          if (this.uspV2) this.uspV2.classList.add('is-fixed-menu');
        }
      }
    }
  
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('is-hidden');
      this.header.classList.remove('is-sticky');
      this.closeSearchModal();
    }
  
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('is-sticky');
      this.header.classList.remove('is-hidden');
    }
  
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('is-hidden', 'is-sticky');
    }
  
    closeSearchModal() {
      this.headerSearch.classList.remove('is-open');
    }
  
    async toggleMenu() {
      await this.loadMenu();


      const isShow = !this.menuLv1.classList.contains('is-open');
  
      this.setHeaderHeightDefault();
      this.setBodyLockIOS(isShow);
  
      if (isShow) {
        this.addClassToParent(1);
        this.menuBtn.classList.add('is-close');
        this.menuLv1.classList.add('is-open');
        this.overlay.classList.add('is-open');
        this.classList.add('is-fixed-menu');
        this.htmlElement.classList.add('off-canvas-menu');
        if (this.topBar) this.topBar.classList.add('is-fixed-menu');
        if (this.uspV2) this.uspV2.classList.add('is-fixed-menu');
      } else {
        this.menuBtn.classList.remove('is-close');
        this.menuLv1.classList.remove('is-open');
        this.overlay.classList.remove('is-open');
        this.classList.remove('is-fixed-menu');
        this.htmlElement.classList.remove('off-canvas-menu');
        if (this.topBar) this.topBar.classList.remove('is-fixed-menu');
        if (this.uspV2) this.uspV2.classList.remove('is-fixed-menu');
  
        this.removeAllSubMenu();
        this.addClassToParent(null);
        this.activeBgLink('removeAll');
      }
    }
  
    toggleMenuWithBtn() {
      this.menuBtn.addEventListener('click', () => {
        document.documentElement.scrollTop = 0;
        window.scrollTo({ top: 0 });
  
        window.debounce(() => {
          this.toggleMenu();
        }, 30)();
      });
    }
  
    activeBgLink(type = 'add', links = []) {
      switch (type) {
        case 'add': {
          links.classList.add('active');
          break;
        }
        case 'remove': {
          links.classList.remove('active');
          break;
        }
        case 'removeLv1': {
          const activeLinksLv1 = this.header.querySelectorAll('.js-mega-menu-link-lv1.active');
          activeLinksLv1.forEach((el) => {
            el.classList.remove('active');
          });
          break;
        }
        case 'removeLv2': {
          const activeLinksLv2 = this.header.querySelectorAll('.js-mega-menu-link-lv2.active');
          activeLinksLv2.forEach((el) => {
            el.classList.remove('active');
          });
          break;
        }
        case 'removeAll': {
          const activeLinks = this.header.querySelectorAll('.js-mega-link.active');
          activeLinks.forEach((el) => {
            el.classList.remove('active');
          });
          break;
        }
      }
    }
  
    addSubMenu(links, subMenus, level) {
      links.forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
  
          const subMenu = el.nextElementSibling;
          const isSubMenuOpen = subMenu.classList.contains('is-open');
          const isLinkLv1 = el.classList.contains('js-mega-menu-link-lv1');
  
          if (!isSubMenuOpen) {
            if (isLinkLv1) {
              this.removeSubMenu(this.menuLv3);
              this.removeSubMenu(subMenus);
              this.activeBgLink('removeLv1');
            } else {
              this.removeSubMenu(subMenus);
              this.activeBgLink('removeLv2');
            }
  
            this.activeBgLink('add', el);
            el.nextElementSibling.classList.add('is-open');
  
            this.addClassToParent(level);
          }
        });
      });
    }
  
    removeSubMenu(subMenus) {
      subMenus.forEach((el) => {
        el.classList.remove('is-open');
      });
    }
  
    removeAllSubMenu() {
      const openedSubMenuLv2 = this.header.querySelector('.js-menu-lv2.is-open');
      const openedSubMenuLv3 = this.header.querySelector('.js-menu-lv3.is-open');
  
      openedSubMenuLv2?.classList?.remove('is-open');
      openedSubMenuLv3?.classList?.remove('is-open');
    }
  
    setBodyLockIOS(isShow) {
      const isIosDevice =
        typeof window !== 'undefined' &&
        window.navigator &&
        window.navigator.platform &&
        (/iP(ad|hone|od)/.test(window.navigator.platform) ||
          (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1));
  
      if (isIosDevice) {
        if (isShow) {
          let topBarHeight = this.topBar?.offsetHeight || 0;
  
          document.body.style.position = 'fixed';
          document.body.style.left = '0';
          document.body.style.top = '0';
          this.header.style.position = 'fixed';
          this.header.style.left = '0';
          this.header.style.top = `${topBarHeight}px`;
  
          if (this.topBar) {
            topBarHeight = this.topBar?.offsetHeight || 0;
            this.topBar.style.position = 'fixed';
            this.topBar.style.left = '0';
            this.topBar.style.top = '0';
          }
        } else {
          document.body.style.position = '';
          document.body.style.left = '';
          document.body.style.top = '';
          this.header.style.position = '';
          this.header.style.left = '';
          this.header.style.top = '';
  
          if (this.topBar) {
            this.topBar.style.position = '';
            this.topBar.style.left = '';
            this.topBar.style.top = '';
          }
        }
      }
    }
  
    showSubMenuDetails() {
      this.linksLv0.forEach((el) => {
        el.addEventListener('click', async (e) => {
          e.preventDefault();
  
          const dataIndex = el.getAttribute('data-index');
          let subMenuOfIndex = this.header.querySelector(
            `.js-mega-menu-link-lv1[data-index="${dataIndex}"]`
          );
          const isShowSubMenu = !subMenuOfIndex?.nextElementSibling?.classList.contains('is-open');
  
          if (isShowSubMenu) {
            const isMenuLv1Showing = this.menuLv1?.classList?.contains('is-open');
  
            this.removeAllSubMenu();
  
            if (!isMenuLv1Showing) {
              await this.toggleMenu();
            }
            
            if(!subMenuOfIndex) {
              subMenuOfIndex = this.header.querySelector(
                `.js-mega-menu-link-lv1[data-index="${dataIndex}"]`
              );
            }
            
            subMenuOfIndex.nextElementSibling.classList.add('is-open');
            this.activeBgLink('removeLv1');
            this.activeBgLink('add', subMenuOfIndex);
            this.addClassToParent(1);
          }
        });
      });
    }
  
    backPrevSub() {
      this.backPrevBtns.forEach((el) => {
        el.addEventListener('click', () => {
          const parentElement = el.parentElement.parentElement;
          const parentClasses = parentElement.classList;
  
          parentElement.classList.remove('is-open');
  
          for (let i = 0; i < parentClasses.length; i++) {
            if (parentClasses[i].startsWith('js-menu-lv')) {
              const level = Number(parentClasses[i].slice(-1)) - 1;
              this.addClassToParent(level);
              break;
            }
          }
        });
      });
    }
  
    addClassToParent(level) {
      this.navMenuContainer = this.navMenuContainer || this.querySelector('.js-menu-nav');
  
      this.navMenuContainer?.classList.remove('is-lv1', 'is-lv2', 'is-lv3');
      if (level) this.navMenuContainer?.classList.add(`is-lv${level}`);
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
}
